import React from 'react';
import DemoFrame from './DemoFrame';
import useDemoPlayer, { useStepCount } from './useDemoPlayer';
import { DEMO_CLASS, DEMO_CLASS_FLOW } from './demoFixtures';
import '../chat/batch/ClassCheckPanel.css';
import '../chat/batch/RosterResultCard.css';

const C = DEMO_CLASS;
const F = DEMO_CLASS_FLOW;
const FIX_COUNT = F.overlapStudents.length;

// 0 명단 → 1 한 번에 작성 → 2 결과 → 3 반 점검 → 4 한 번에 고치는 중 → 5(완성) 고친 결과 + 학생별 모아두기
const STEPS = [1300, 2100, 1300, 1900, 1600];

const ClassFlowDemo = ({ surface = 'home', title = '반 전체 생기부', autoStart = false }) => {
  const player = useDemoPlayer({ steps: STEPS, surface, feature: 'class_flow', autoStart });
  const { phase, done, paused } = player;
  const written = useStepCount(C.size, { active: phase === 1, complete: phase > 1, paused, tickMs: 62 });
  const fixed = useStepCount(FIX_COUNT, { active: phase === 4, complete: phase > 4, paused, tickMs: 450 });

  return (
    <DemoFrame title={title} player={player} className="wqdemo-flow">
      {phase < 2 ? (
        <>
          <div className="wqdemo-roster">
            <div className="wqdemo-roster-head">
              <strong>{C.label} 명단</strong>
              <span>{C.size}명</span>
            </div>
            <div className="wqdemo-name-chips">
              {C.names.slice(0, 6).map((name) => (
                <span key={name} className="wqdemo-name-chip">{name}</span>
              ))}
              <span className="wqdemo-name-chip">외 {C.size - 6}명</span>
            </div>
          </div>
          <div className="wqdemo-progress">
            <div className="wqdemo-progress-info">
              <span>{phase === 0 ? '한 번에 쓸 준비가 됐어요' : '생기부를 쓰고 있어요'}</span>
              <b>{written}/{C.size}명</b>
            </div>
            <div className="wqdemo-progress-bar">
              <div className="wqdemo-progress-fill" style={{ width: phase >= 1 ? '100%' : '0%' }} />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="wqdemo-roster-head wqdemo-in">
            <strong>{C.size}명 생기부 완성!</strong>
          </div>
          <ul className="wqdemo-result-list wqdemo-in">
            {F.results.map((r, i) => (
              <li key={r.name}>
                <span className="wqdemo-result-no">{i + 1}</span>
                <span className="wqdemo-result-name">{r.name}</span>
                <span className="wqdemo-result-bytes">{r.bytes.toLocaleString()} / {F.byteLimit.toLocaleString()}</span>
              </li>
            ))}
          </ul>
        </>
      )}

      {phase >= 3 && (
        <section className="class-check wqdemo-in">
          <div className="class-check-head">
            <div className="class-check-title">
              <strong>다른 학생과 겹치는 문장 1곳</strong>
              <span>&apos;{F.overlapSentence}&apos;</span>
            </div>
          </div>
          {done ? (
            <div className="class-check-fix-all wqdemo-fixall is-done">학생마다 다른 문장으로 고쳤어요</div>
          ) : (
            <div className={`class-check-fix-all wqdemo-fixall${phase === 4 ? ' is-busy' : ''}`}>
              {phase === 4 ? `고치는 중 ${fixed}/${FIX_COUNT}` : `겹치지 않게 ${FIX_COUNT}명 고치기`}
            </div>
          )}
          <ul className="class-check-list">
            {F.overlapStudents.map((name, i) => (
              <li key={name}>
                <span className="class-check-name">{name}</span>
                {(done || (phase === 4 && i < fixed)) ? (
                  <span className="wqdemo-fixed">고쳤어요</span>
                ) : (
                  <span className="wqdemo-fake-btn">고치기</span>
                )}
              </li>
            ))}
          </ul>
        </section>
      )}

      {done && (
        <section className="roster-result-card is-linked wqdemo-in">
          <span>&apos;{C.label}&apos;(으)로 모아뒀어요</span>
          <span className="wqdemo-link">학생별 기록 보기</span>
        </section>
      )}
    </DemoFrame>
  );
};

export default ClassFlowDemo;
